import { useEffect, useState } from 'react'

import {
  getCachedBlob,
  prefetchImageToBlob
} from 'helpers/mediaPrefetch'

export function useCachedStoryImage(
  url?: string | null
): string | null {
  const [image, setImage] = useState<{
    url: string | null
    blob: string | null
  }>(() => ({
    url: url ?? null,
    blob: url ? getCachedBlob(url) : null
  }))

  useEffect(() => {
    let active = true

    if (!url) {
      setImage({ url: null, blob: null })
      return
    }

    const cached = getCachedBlob(url)

    if (cached) {
      setImage({ url, blob: cached })
      return
    }

    setImage({ url, blob: null })

    void prefetchImageToBlob(url).then(() => {
      if (!active) return

      setImage({
        url,
        blob: getCachedBlob(url)
      })
    })

    return () => {
      active = false
    }
  }, [url])

  if (!url) return null

  return image.url === url
    ? image.blob
    : getCachedBlob(url)
}